import { Tag } from '../@types';

export interface PostOrGetTagsParams {
	names: string[];
	project: number;
}

export const postOrGetTags = async ({ names = [], project }: PostOrGetTagsParams) => {
	// vars
	const tags: Tag[] = [];

	if (names.length) {
		// session
		const accessToken = sessionStorage.getItem('accessToken');
		const idToken = sessionStorage.getItem('idToken');

		const headers = {
			Authorization: `Bearer ${accessToken}`,
			User: String(idToken),
		};

		// for each name
		for (let i = 0; i < names.length; i++) {
			// get tag by name
			const fetchGetTags = await fetch(
				`${process.env.REACT_APP_API_URL}/tags?name=${names[i]}&project=${project}`,
				{
					headers,
				}
			);

			const resGetTags = await fetchGetTags.json();

			if (resGetTags.error) {
				console.debug(`There was an error getting the tag with the name ${names[i]}.`, resGetTags);
			} else if (resGetTags.data.length) {
				// add tag to tags array
				tags.push(resGetTags.data[0] as Tag);
			} else {
				// post tag if it was not fetched
				const fetchPostTag = await fetch(`${process.env.REACT_APP_API_URL}/tags`, {
					method: 'post',
					headers,
					body: JSON.stringify({
						name: names[i],
						project,
					}),
				});

				const resPostTag = await fetchPostTag.json();

				if (resPostTag.error) {
					console.debug(
						`There was an error posting the tag with the name ${names[i]}.`,
						resPostTag
					);
				} else if (resPostTag.data) {
					// add tag to tags array
					tags.push(resPostTag.data as Tag);
				}
			}
		}
	}

	return tags;
};
